import { ApiType } from "@gymflow/common";
import { ProductOrderSummaryDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";

export function useQueryProductSummary(
  {
    api,
    opts,
    enabled,
  }: {
    api: ApiType;
    enabled?: boolean;
    opts?: Parameters<ApiType["productApi"]["summary"]>[0];
  },
  queryOptions?: Omit<UseQueryOptions<ProductOrderSummaryDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: productQueryKeys.summary(opts),
    queryFn: async () => {
      return (await api.productApi.summary(opts!)).data;
    },
    enabled: !!opts && enabled,
    ...queryOptions,
  });
}
